import { useMutation } from 'react-query';
import publicRegisterApi, { PublicRegisterPayload } from 'services/publicRegister';

export const usePublicRegister = () =>
  useMutation((body: PublicRegisterPayload) => publicRegisterApi.register(body), { mutationKey: 'publicRegister' });
